import React, { useState, useEffect, memo } from 'react';
import { Tag } from 'antd';

export const ExportTimer = memo(({ cswExpiresAt, isExpired = false, isMobile }) => {
    const [remainingTime, setRemainingTime] = useState(0);

    useEffect(() => {
        if (!cswExpiresAt) {
            setRemainingTime(0);
            return undefined;
        }

        const expiresAt = new Date(cswExpiresAt).getTime();

        const tick = () => {
            const remaining = expiresAt - Date.now();
            setRemainingTime(remaining > 0 ? remaining : 0);
        };

        tick();
        const interval = setInterval(tick, 1000);

        return () => clearInterval(interval);
    }, [cswExpiresAt]);

    const formatTime = (time) => {
        const totalSeconds = Math.floor(time / 1000);
        const hours = Math.floor(totalSeconds / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;

        // Pad hours, minutes, and seconds with leading zeros
        const pad = (num) => (num < 10 ? `0${num}` : num);

        return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
    };

    const getColor = (time) => {
        const totalSeconds = Math.floor(time / 1000);
        if (totalSeconds > 18 * 60 * 60) return 'green';
        else if (totalSeconds > 12 * 60 * 60) return 'blue';
        else if (totalSeconds > 6 * 60 * 60) return 'orange';
        else return 'red';
    };

    if (!cswExpiresAt && !isExpired) {
        return null;
    }

    const showExpired = isExpired || remainingTime <= 0;

    return (
        <Tag color={!showExpired ? getColor(remainingTime) : 'red'} style={{ margin: 0 }}>
            {!showExpired ? (
                <span>
                    {isMobile
                        ? <strong>⏱ {formatTime(remainingTime)}</strong>
                        : <>Chat Expires In: <strong>{formatTime(remainingTime)}</strong></>
                    }
                </span>
            ) : (
                <span>{isMobile ? 'Exp.' : 'Chat has expired.'}</span>
            )}
        </Tag>
    );
});